import { ReactComponent as RevokeIcon } from "../assets/revoke.svg";
import React, { ComponentType, useState } from "react";
import { Tooltip } from "@gw/web-basic-components";
import { isEqualWith } from "lodash";
import moment from "moment";

const equal = (a, b) =>
  isEqualWith(a, b, (i, j) => {
    if (moment.isMoment(i) && moment.isMoment(j)) {
      return i.isSame(j);
    }
  });

export default function withRevoke<
  P,
  T extends {
    value?: P;
    onChange?: (val?: P, ...rest: any[]) => void;
  }
>(
  Comp: ComponentType<T>
): ComponentType<
  T & {
    initialValue?: P;
    onRevoke?: () => void;
  }
> {
  return (props) => {
    const { initialValue, value, onChange, onRevoke, ...rest } = props;
    const [hover, setHover] = useState(false);
    const isEqual = equal(initialValue, value);
    const showRevoke = hover && !isEqual;

    return (
      <div
        data-state={!isEqual ? "changed" : "origin"}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {/* @ts-ignore */}
        <Comp {...rest} value={value} onChange={onChange} />
        {showRevoke && (
          <Tooltip title="撤销">
            <RevokeIcon
              onClick={() => {
                onChange?.(initialValue);
                onRevoke?.();
              }}
              className="wbuc-absolute wbuc-right-2 wbuc-top-[calc(50%-0.4375rem)] wbuc-h-[0.875rem] wbuc-w-[0.875rem] wbuc-cursor-pointer"
            />
          </Tooltip>
        )}
      </div>
    );
  };
}
